var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDistributionIconDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583008,
    y: 0.500977,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22204_80753",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58301 8.50098H24.583V24.501H8.58301V8.50098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22204_80753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8529 16.617H16.4671V10.2313C16.4671 10.1527 16.4029 10.0885 16.3243 10.0885H15.86C14.9138 10.0875 14.0036 10.268 13.1294 10.6301C12.2552 10.9922 11.4838 11.508 10.8154 12.1777C10.4895 12.5026 10.198 12.8558 9.9408 13.2374C9.68364 13.6189 9.46563 14.0217 9.28679 14.4456C8.91536 15.326 8.72607 16.2599 8.72607 17.2242C8.72607 18.1885 8.91536 19.1206 9.28679 20.0009C9.64572 20.8491 10.16 21.6134 10.8154 22.2688C11.4707 22.9241 12.2332 23.4384 13.0832 23.7974C13.5226 23.9838 13.9762 24.1243 14.4441 24.219C14.9119 24.3138 15.3845 24.3607 15.8618 24.3599C16.808 24.3608 17.7182 24.1803 18.5924 23.8182C19.4667 23.4562 20.238 22.9403 20.9065 22.2706C21.5618 21.6152 22.0761 20.8527 22.435 20.0027C22.6214 19.5633 22.762 19.1097 22.8567 18.6419C22.9514 18.1741 22.9984 17.7015 22.9975 17.2242V16.7599C22.9957 16.6813 22.9315 16.617 22.8529 16.617ZM24.4225 15.626L24.3761 15.1224C24.2243 13.4795 23.4957 11.9295 22.3207 10.7599C21.7338 10.1734 21.0647 9.70398 20.3136 9.35156C19.5624 8.99914 18.7737 8.78465 17.9475 8.7081L17.4421 8.66168C17.3582 8.65453 17.2868 8.71882 17.2868 8.80275V15.6545C17.2868 15.7331 17.3511 15.7974 17.4296 15.7974L24.2797 15.7795C24.3636 15.7777 24.4297 15.7081 24.4225 15.626Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDistributionIconDisable);
export default __webpack_public_path__ + "static/media/timeDistributionIconDisable.8801aa633298aea92dc800d3dbe0a597.svg";
export { ForwardRef as ReactComponent };